import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/test',
        name: 'test',
        component: () => import(/* webpackChunkName: "test" */ '../views/test'),
    },
    {
        path: '/mine',
        name: 'index',
        component: () => import(/* webpackChunkName: "create" */ '../views/index'),
    },
    {
        path: '/create/:pageId?',
        name: 'create',
        component: () => import(/* webpackChunkName: "create" */ '../views/create'),
    },
    {
        path: '/createTemplate/:pageId?',
        name: 'createTemplate',
        component: () => import(/* webpackChunkName: "createTemplate" */ '../views/template/createTemplate'),
    },
    {
        path: '/template',
        name: 'template',
        component: () => import(/* webpackChunkName: "template" */ '../views/template/index'),
    },
    {
        path: '/previewTemplate/:pageId',
        name: 'previewTemplate',
        component: () => import(/* webpackChunkName: "test" */ '../views/template/detail'),
    },
    {
        path: '/templateSetting/:pageId',
        name: 'templateSetting',
        component: () => import(/* webpackChunkName: "templateSetting" */ '../views/template/templateSetting'),
    },
    {
        path: '/choose/:pageId',
        name: 'choose',
        component: () => import(/* webpackChunkName: "choose_topic" */ '../views/choose_topic'),
    },
    {
        path: '/topic/:pageId/:type?',
        name: 'topic',
        component: () => import(/* webpackChunkName: "test" */ '../views/topic'),
    },
    {
        path: '/topic2/:pageId/:topicId?',
        name: 'topic2',
        component: () => import(/* webpackChunkName: "topic" */ '../views/topic'),
    },
    {
        path: '/skip/:pageId/:topicId?',
        name: 'skip',
        component: () => import(/* webpackChunkName: "skip" */ '../views/skip'),
    },
    {
        path: '/show/:pageId/:topicId?/:type',
        name: 'show',
        component: () => import(/* webpackChunkName: "show" */ '../views/show'),
    },
    {
        path: '/show-condition/:pageId/:topicId?/:type',
        name: 'show-condition',
        component: () => import(/* webpackChunkName: "show-condition" */ '../views/show-condition'),
    },
    {
        path: '/label/:pageId/:topicId?/:type',
        name: 'label',
        component: () => import(/* webpackChunkName: "show" */ '../views/label'),
    },
    {
        path: '/edit/:pageId',
        name: 'edit',
        component: () => import(/* webpackChunkName: "test" */ '../views/edit'),
    },
    {
        path: '/preview/:pageId',
        name: 'preview',
        component: () => import(/* webpackChunkName: "test" */ '../views/preview'),
    },
    {
        path: '/question/:pageId',
        name: 'question',
        component: () => import(/* webpackChunkName: "test" */ '../views/question'),
    },
    {
        path: '/statistics',
        name: 'statistics',
        component: () => import(/* webpackChunkName: "test" */ '../views/statistics'),
    },
    {
        path: '/index',
        name: 'mine',
        component: () => import(/* webpackChunkName: "mine" */ '../views/mine'),
    },
    {
        path: '/share/:pageId',
        name: 'share',
        component: () => import(/* webpackChunkName: "share" */ '../views/share'),
    },
    {
        path: '/data/:pageId',
        name: 'data',
        component: () => import(/* webpackChunkName: "data" */ '../views/data'),
    },
    {
        path: '/setting/:pageId',
        name: 'setting',
        component: () => import(/* webpackChunkName: "setting" */ '../views/setting'),
    },
    {
        path: '/publish/:pageId',
        name: 'publish',
        component: () => import(/* webpackChunkName: "publish" */ '../views/publish'),
    },
    {
        path: '/customLabel/:pageId',
        name: 'customLabel',
        component: () => import(/* webpackChunkName: "publish" */ '../views/customLabel'),
    },
    {
        path: '/sendingRange/:pageId',
        name: 'sendingRange',
        component: () => import(/* webpackChunkName: "sendingRange" */ '../views/sendingRange'),
    },
    {
        path: '/sendingRangeSetting/:pageId',
        name: 'sendingRangeSetting',
        component: () => import(/* webpackChunkName: "sendingRangeSetting" */ '../views/sendingRangeSetting'),
    },
    {
        path: '/checkboxOptionSet/:pageId/:topicId?',
        name: 'checkboxOptionSet',
        component: () => import(/* webpackChunkName: "setting" */ '../views/checkboxOptionSet'),
    },
    {
        path: '/batch/:pageId/:topicId?',
        name: 'batch',
        component: () => import(/* webpackChunkName: "setting" */ '../views/batch'),
    },
    {
        path: '/notice/:pageId',
        name: 'notice',
        component: () => import(/* webpackChunkName: "setting" */ '../views/notice'),
    },
    {
        path: '*',
        name: '404',
        component: () => import(/* webpackChunkName:"404" */'@components/tip-page/404'),
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

export default router
